import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';

const DropdownIcon = ({ colorVariant, ...props }) => {
  const color = colorVariant || '#0C3327';

  return <ExpandMoreRoundedIcon {...props} fontSize="small" sx={{ color: `${color} !important` }} />;
};

export default DropdownIcon;
